angular.module('app').config(receivedPaymentsRouting);

function receivedPaymentsRouting($routeProvider) {
  $routeProvider
    .when('/received_payments', {
      pageTitle: 'PAYMENTS_FROM_CLIENTS',
      template: '<received-payments-page></received-payments-page>',
      menu: 'sales',
      accessPermission: 'index_receivedpayment_accountadmin',
      authReq: true,
    })
    .when('/received_payments/new', {
      // params: {
      //   invoiceId: null,
      //   clientId: null,
      //   currencyId: null,
      // },
      pageTitle: 'ADD_PAYMENTS_RECEIVED_FROM_CLIENT',
      template: '<received-payment-page></received-payment-page>',
      breadcrumb: {
        label: 'PAYMENTS_FROM_CLIENTS',
        parent: 'received_payments',
        ajs: true,
      },
      menu: 'sales',
      accessPermission: 'create_receivedpayment_accountadmin',
      authReq: true,
    })
    .when('/received_payments/:id', {
      // params: {
      //   mode: null,
      // },
      pageTitle: 'EDIT_PAYMENT',
      template: '<received-payment-page></received-payment-page>',
      breadcrumb: {
        label: 'PAYMENTS_FROM_CLIENTS',
        parent: 'received_payments',
        ajs: true,
      },
      menu: 'sales',
      accessPermission: 'show_receivedpayment_accountadmin',
      authReq: true,
    });
}

receivedPaymentsRouting.$inject = ['$routeProvider'];
